import { defineMessages } from 'react-intl';

export default defineMessages({
  closeButton: {
    id: 'common.button.closeButton',
    defaultMessage: 'Chiudi',
    description: 'Label shown inside the button used to close alerts',
  },
  linkToLogin: {
    id: 'common.button.linkToLogin',
    defaultMessage: 'login',
    description: 'Label shown in the links redirecting to the login page',
  },
  linkBackToLogin: {
    id: 'common.button.linkBackToLogin',
    defaultMessage: 'Torna alla ',
    description:
      'Label shown in the links with the back button redirectingback to the login page',
  },
  backLink: {
    id: 'common.button.backLink',
    defaultMessage: 'Indietro',
    description: 'Link to go back',
  },
  ahead: {
    id: 'common.button.ahead',
    defaultMessage: 'Avanti',
    description: 'button text to fo ahead ',
  },
  logout: {
    id: 'common.button.logout',
    defaultMessage: 'Logout',
    description: 'Text use for identfy logout buttons or link',
  },
  confirm: {
    id: 'common.button.confirm',
    defaultMessage: 'Conferma',
    description: 'Text use for identfy confirm buttons or link',
  },
  ok: {
    id: 'common.button.ok',
    defaultMessage: 'Ok',
  },
  sign: {
    id: 'common.button.sign',
    defaultMessage: 'firma',
    description: 'Text use for buttons or link for the signature',
  },
  cancel: {
    id: 'common.button.cancel',
    defaultMessage: 'Annulla',
    description: 'Label for cancel button',
  },
  search: {
    id: 'common.button.search',
    defaultMessage: 'cerca',
    description: 'Label for search button',
  },
  research: {
    id: 'common.button.research',
    defaultMessage: 'ricerca',
    description: 'Label for research button',
  },
  send: {
    id: 'common.button.send',
    defaultMessage: 'invia',
    description: 'Label for send button',
  },
  downloadPdf: {
    id: 'common.button.downloadPdf',
    defaultMessage: 'PDF',
    description: 'Label for download PDF button/link',
  },
  downloadXls: {
    id: 'common.button.downloadXls',
    defaultMessage: 'XLS',
    description: 'Label for download XLS button/link',
  },
  pdf: {
    id: 'common.button.pdf',
    defaultMessage: 'PDF',
    description: 'Label for  PDF button/link',
  },
  xls: {
    id: 'common.button.xls',
    defaultMessage: 'XLS',
    description: 'Label for  XLS button/link',
  },
  applyButton: {
    id: 'common.button.applyButton',
    defaultMessage: 'Applica',
    description: 'apply Button',
  },
  previousButton: {
    id: 'common.button.previousButton',
    defaultMessage: 'Precedente',
    description:
      'Label for the "previous" button shown, for example, in the calendar picker view in the mobile app',
  },
  nextButton: {
    id: 'common.button.nextButton',
    defaultMessage: 'Prossimo',
    description:
      'Label for the "next" button shown, for example, in the calendar picker view in the mobile app',
  },
  continuedButton: {
    id: 'common.button.continued',
    defaultMessage: 'Continua',
    description: 'Label for the "continued" button',
  },
  MyAziumtLabel: {
    id: 'common.button.MyAziumtLabel',
    defaultMessage: 'MyAziumt',
    description: 'label MyAzimut',
  },
  print: {
    id: 'common.button.print',
    defaultMessage: 'Stampa',
    description: 'Print',
  },
});
